import { LOB_IDS } from "@/shared/common/static";
import { isB2CProductVisible, isLifeHomeContentEnabled } from "@/shared/config/header.config";
import { Car, Heart, HeartPulse, Home, Plane, TrendingUp, Wallet } from "lucide-react";

export type AddQuoteProductKey =
  | "home"
  | "health"
  | "life"
  | "motor"
  | "travel"
  | "market-linked"
  | "income";

export type AddQuoteProduct = {
  key: AddQuoteProductKey;
  label: string;
  icon: typeof Home;
  lobId?: number;
  accentClassName: string;
  available: boolean;
  // Shown but not clickable — there is no journey to navigate to yet.
  comingSoon?: boolean;
};

export const ADD_QUOTE_PRODUCTS: AddQuoteProduct[] = [
  {
    key: "travel",
    label: "Add Travel Quotes",
    icon: Plane,
    lobId: LOB_IDS.TRAVEL,
    accentClassName: "bg-sky-50 text-sky-700 border-sky-100",
    available: isB2CProductVisible("travel"),
  },
  {
    key: "health",
    label: "Add Health Quotes",
    icon: HeartPulse,
    lobId: LOB_IDS.HEALTH,
    accentClassName: "bg-rose-50 text-rose-700 border-rose-100",
    available: isB2CProductVisible("health"),
  },
  {
    key: "motor",
    label: "Add Motor Quotes",
    icon: Car,
    lobId: LOB_IDS.MOTOR,
    accentClassName: "bg-amber-50 text-amber-700 border-amber-100",
    available: isB2CProductVisible("motor"),
  },
  {
    key: "life",
    // Same journey either way — only the wording follows the life-focused content.
    label: isLifeHomeContentEnabled() ? "Add Term Life Quotes" : "Add Life Quotes",
    icon: Heart,
    lobId: LOB_IDS.LIFE,
    accentClassName: "bg-violet-50 text-violet-700 border-violet-100",
    available: isB2CProductVisible("life"),
  },
  {
    key: "home",
    label: "Add Home Quotes",
    icon: Home,
    accentClassName: "bg-lime-50 text-lime-700 border-lime-100",
    available: isB2CProductVisible("home"),
  },
  // No journey yet, so these stay on the quotes page instead of navigating.
  {
    key: "market-linked",
    label: "Add Market Linked Quotes",
    icon: TrendingUp,
    accentClassName: "bg-indigo-50 text-indigo-700 border-indigo-100",
    available: isLifeHomeContentEnabled(),
    comingSoon: true,
  },
  {
    key: "income",
    label: "Add Income Product Quotes",
    icon: Wallet,
    accentClassName: "bg-emerald-50 text-emerald-700 border-emerald-100",
    available: isLifeHomeContentEnabled(),
    comingSoon: true,
  },
];

export const getAddQuoteProduct = (product?: string) =>
  ADD_QUOTE_PRODUCTS.find((item) => item.key === product);

export const getAddQuoteProductByLob = (lobId?: number | string | null) => {
  if (lobId === null || lobId === undefined || lobId === "") {
    return undefined;
  }

  const numericLobId = Number(lobId);
  if (Number.isNaN(numericLobId)) {
    return undefined;
  }

  return ADD_QUOTE_PRODUCTS.find((item) => item.lobId === numericLobId);
};
